import api from '@/api/order'

const state = {
  registerDate: '',
  sortType: '0',
  registerDateTypeSelectVisible: false,
  calendarVisible: false,
  registerDateTypes: [
    {
      value: '0',
      text: '全部'
    },
    {
      value: '1',
      text: '选择日期'
    }
  ],
  sortTypeSelectVisible: false,
  sortTypes: [
    {
      value: '0',
      text: '注册时间降序'
    },
    {
      value: '1',
      text: '注册时间升序'
    }
  ],
  pageSize: 10,
  totalCount: 0,
  pageCount: 0,
  invitationalAgents: [],
  loadingStatus: 'DONE', // LOADING, DONE
  currentPageIndex: 0
}

const getters = {
  registerDate (state) {
    return state.registerDate
  },
  registerDateTypes (state) {
    return state.registerDateTypes
  },
  registerDateType (state) {
    return state.registerDate && state.registerDate !== '' ? '1' : '0'
  },
  registerDateTypeSelectVisible (state) {
    return state.registerDateTypeSelectVisible
  },
  sortType (state) {
    return state.sortType
  },
  sortTypes (state) {
    return state.sortTypes
  },
  calendarVisible (state) {
    return state.calendarVisible
  },
  sortTypeSelectVisible (state) {
    return state.sortTypeSelectVisible
  },
  totalCount () {
    return state.totalCount
  },
  invitationalAgents () {
    return state.invitationalAgents
  },
  isLoading (state) {
    return state.loadingStatus === 'LOADING'
  },
  canLoadMore (state) {
    return state.currentPageIndex < state.pageCount
  }
}

const mutations = {
  SET_SORT_TYPE (state, sortType) {
    state.sortType = sortType
  },
  SET_CALENDAR_VISIBLE (state, calendarVisible) {
    state.calendarVisible = calendarVisible
  },
  SET_SORT_TYPE_SELECT_VISIBLE (state, sortTypeSelectVisible) {
    state.sortTypeSelectVisible = sortTypeSelectVisible
  },
  SET_REGISTER_DATE (state, registerDate) {
    state.registerDate = registerDate
  },
  SET_REGISTER_DATE_TYPE_SELECT_VISIBLE (state, registerDateTypeSelectVisible) {
    state.registerDateTypeSelectVisible = registerDateTypeSelectVisible
  },
  SET_LOADING_STATUS (state, loadingStatus) {
    state.loadingStatus = loadingStatus
  },
  SET_CURRENT_PAGE_INDEX (state, pageIndex) {
    state.currentPageIndex = pageIndex
  },
  SET_DATA (state, queryApiResponseResult) {
    state.pageCount = queryApiResponseResult.pageCount
    state.totalCount = queryApiResponseResult.rowCount
    for (let i = 0; i < queryApiResponseResult.agentInfo.length; i++) {
      state.invitationalAgents.push(queryApiResponseResult.agentInfo[i])
    }
  },
  RESET (state) {
    state.currentPageIndex = 0
    state.registerDate = ''
    state.sortType = '0'
    state.calendarVisible = false
    state.sortTypeSelectVisible = false
    state.totalCount = 0
    state.pageCount = 0
    state.invitationalAgents = []
    state.loadingStatus = 'DONE'
    state.currentPageIndex = 0
  },
  CLEARE_DATA (state) {
    state.pageCount = 0
    state.totalCount = 0
    state.invitationalAgents = []
  }
}

const actions = {
  queryInvitedAgents ({ commit, getters, state }) {
    commit('SET_LOADING_STATUS', 'LOADING')
    commit('SET_CURRENT_PAGE_INDEX', state.currentPageIndex + 1)
    return api.queryAgentsOfCurrentUserInvited({
      pageIndex: state.currentPageIndex,
      pageSize: state.pageSize,
      sortType: state.sortType,
      registerDate: state.registerDate
    }).then(res => {
      let apiResponse = res.data
      if (apiResponse.returnCode !== 0) {
        throw new Error('获取数据失败')
      }

      let data = apiResponse.result
      commit('SET_DATA', data)
    }).finally(() => {
      commit('SET_LOADING_STATUS', 'DONE')
    })
  },
  changeRegisterDate ({ commit, getters, state, dispatch }) {
    commit('SET_CURRENT_PAGE_INDEX', 0)
    commit('CLEARE_DATA')
    return dispatch('queryInvitedAgents')
  },
  changeSortType ({ commit, getters, state, dispatch }) {
    commit('SET_CURRENT_PAGE_INDEX', 0)
    commit('CLEARE_DATA')
    return dispatch('queryInvitedAgents')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/invitational.js